// Session keys
export const FILTER_KEY = 'UserFilterSetting';
